import { ReactComponent as IconTechnicalError } from '../../../assets/huoltosivu.svg';
import i18n from 'i18n';
import { ErrorPage } from 'individual/components/ErrorPage';

/**
 * Displays a generic error message page for technical error
 */
export const TechnicalError = () => {
  return (
    <ErrorPage
      componentId='lifepurchase-technical-error'
      headerText={i18n.t('error.generic')}
      errorMessageText={i18n.t('error.not-available')}
      image={<IconTechnicalError />}
    />
  );
};
